
function CardBox(props) {
  return (
    <div className="card-box">
        <img loading="lazy" src={props.cardImg} alt="card" />
        <div className="card-text-content">
          <div className="top-links">
            <div className="d-flex align-items-center justify-content-start gap-1">
              <img  alt="person" loading="lazy" src="/images/icons/user-icon.svg" className="m-0"/>
              <p className="m-0">Admin</p>
            </div>
            <div className="d-flex align-items-center justify-content-start gap-1">
              <img  alt="comment" loading="lazy" src="/images/icons/comment-icon.svg" className="m-0"/>
              <p className="m-0">Comment</p>
            </div>
          </div>
          <h5>{props.title}</h5>
          <p className="mb-2">{props.content}</p>
          <a href={props.readMoreRef} className="read-more-anchor">Read More</a>
        </div>
    </div>
  )
}

export default CardBox